import { render, staticRenderFns } from "./DesktopVideoPlayPage.vue?vue&type=template&id=28c52685&scoped=true"
import script from "./DesktopVideoPlayPage.vue?vue&type=script&lang=js"
export * from "./DesktopVideoPlayPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopVideoPlayPage.vue?vue&type=style&index=0&id=28c52685&prod&scoped=true&lang=css"
import style1 from "./DesktopVideoPlayPage.vue?vue&type=style&index=1&id=28c52685&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c52685",
  null
  
)

export default component.exports